import React from "react";

import { CardLayout } from "../cards";
import { Button } from "../elements";
import { AppHeading } from "../generalComponets";

export const YardActions = ({ handleAddStock, handleMoveStock, handleDownloadReport }) => {
  return (
    <CardLayout>
      <AppHeading title={"Actions"} icon={"queue"} />

      <Button onClick={handleAddStock} icon={"add"} text={"Add Stock"} className={"mc-btn primary m-2"} />

      <Button onClick={handleMoveStock} icon={"local_shipping"} text={"Move Stock"} className={"mc-btn primary m-2"} />

      <Button onClick={handleDownloadReport} icon={"download"} text={"Download Report"} className={"mc-btn primary m-2"} />
    </CardLayout>
  );
};
